<script setup lang="ts">
import { useAgencySelectField } from "./useAgencySelectField";

const props = defineProps<{ companyId: string; contentClass?: string; disabled?: boolean }>();

const agencyId = defineModel<string | undefined>("agencyId", { default: undefined });

const { agencyItems, isLoading } = useAgencySelectField(() => props.companyId);
</script>

<template>
  <AwSelectMenu
    v-model="agencyId"
    class="w-full"
    :items="agencyItems"
    value-key="value"
    label-key="label"
    :content-class="contentClass"
    :disabled="disabled"
    :is-loading="isLoading"
    :placeholder="$t('companies.agencySelect.singlePlaceholder')"
  />
</template>
